<template>
  <div
    v-if="visible"
    class="alpon-notice"
    role="status">
    <svg
      class="glyph"
      viewBox="0 0 24 24"
      aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>

    <p class="message">
      <span class="medium">{{ notice.title }}</span>
      {{ notice.text }}
    </p>

    <a
      v-if="notice.showConsole && consoleURL"
      class="console-link medium"
      :href="consoleURL"
      target="_blank"
      rel="noopener">
      Go to ALPON Console
      <svg
        class="external"
        viewBox="0 0 24 24"
        aria-hidden="true">
        <path d="M14 4h6v6M20 4l-9 9M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" />
      </svg>
    </a>
  </div>
</template>

<script>
// "upcoming" before the migration day, "moved" after it
const PHASE = "upcoming";

const NOTICES = {
  upcoming: {
    title: "ALPON is moving to its own platform on November 22, 07:00–12:00 UTC.",
    text: "Fleets, Container Registry and Remote Terminal will move to the ALPON Console. Your SIMs stay in Sixfab Connect.",
    showConsole: false,
  },
  moved: {
    title: "ALPON has moved to its own platform.",
    text: "Fleets, Container Registry and Remote Terminal are now in the ALPON Console. Your SIMs stay in Sixfab Connect.",
    showConsole: true,
  },
};

const ALPON_ASSET_TYPES = ["alpon_x4", "alpon_x5_ai", "axis_gw"];

/**
 * Notice about the ALPON migration, shown to accounts that have ALPON assets.
 */
export default {
  name: "AlponNoticeBar",

  data() {
    return {
      hasAlponAssets: false,
    };
  },

  computed: {
    notice() {
      return NOTICES[PHASE];
    },

    visible() {
      return this.hasAlponAssets;
    },

    consoleURL() {
      return process.env.VUE_APP_ALPON_CONSOLE_URL || "";
    },
  },

  created() {
    this.checkAlponAssets();
  },

  methods: {
    async checkAlponAssets() {
      const params = new URLSearchParams({limit: 1});
      ALPON_ASSET_TYPES.forEach((t) => params.append("types[]", t));
      const response = await this.axios.get("/assets", {params});
      this.hasAlponAssets = response.status === 200 && response.data.total_count > 0;
    },
  },
};
</script>

<style scoped>
.alpon-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px 12px 20px;
  background: #fdefd3;
  border-bottom: 1px solid #f2d39a;
  color: #5c3d00;
}

.glyph {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  fill: none;
  stroke: #c27c0e;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.message {
  flex: 1;
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #5c3d00;
}

.message .medium {
  color: #3f2a00;
}

.console-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 6px;
  background: #7a4b00;
  color: #fff;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.console-link:hover {
  background: #5c3800;
}

.external {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}


@media (max-width: 820px) {
  .alpon-notice {
    flex-wrap: wrap;
    padding: 10px 12px;
  }

  .message {
    flex-basis: calc(100% - 64px);
  }

  .console-link {
    margin-left: 32px;
  }
}
</style>
